export default __webpack_public_path__ + "media/images/about_us/man-reading-8de904c82128ab226d507a298867ea75.png";